import { AnalyticsService } from '@alison/analytics/client';
import { TrackingProvider } from '@alison/ui';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { TourProvider } from '../components/tour/TourProvider.js';
import { AlisonRunData } from '../components/workflows/alison-run/AlisonRunData.js';
import { AlisonRunLayer } from '../components/workflows/alison-run/ui/AlisonRunLayer.js';
import { AnalyticsBootstrap } from '../lib/AnalyticsBootstrap.js';

function RootComponent(): ReactNode {
  return (
    <TrackingProvider track={(event, properties) => AnalyticsService.track(event, properties)}>
      <AnalyticsBootstrap />
      <TourProvider>
        <AlisonRunData>
          <Outlet />
          <AlisonRunLayer />
        </AlisonRunData>
      </TourProvider>
    </TrackingProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
});
